import { useAuth } from "react-oidc-context";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import "./../App.css";
import { useState, useEffect } from "react";
import { OnboardCampaign, ValidateCampaign } from "../services/ApiService";
import { SupportedChannel } from "../services/ConstantService";
import { Button, Alert, Spin } from 'antd';

function OnboardCampaignUI() {
  const auth = useAuth();
  const [campaign_id, setCampaignID] = useState("");
  const [partnerID, setPartnerID] = useState("");
  const [advertiserID, setAdvertiserID] = useState("");
  const [campaignName, setCampaignName] = useState("");
  const [isCampaignIdDisabled, setIsCampaignIdDisabled] = useState(false);
  const [channel, setChannel] = useState("");
  const [tccc_ou, setTCCCOU] = useState("");
  const [tccc_country, setTCCC_Country] = useState("");
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [buttonText, setButtonText] = useState("Validate Campaign");
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (showBanner) {
      console.log("asfdafafdsa");
      const timer = setTimeout(() => {
        setShowBanner(false);
      }, 5000); // Auto-hide after 5s

      return () => clearTimeout(timer);
    }
  }, [showBanner]);
  const handleValidateCampaignClick = async (e) => {
    e.preventDefault(); // Prevent page refresh
    setLoading(true); // Start loading state
    if (buttonText === "Validate Campaign") {
      if (campaign_id === "") {
        alert("Please provide a valid campaign ID");
        setLoading(false); // Stop loading state
        return;
      }
      try {
        let ret = await ValidateCampaign(auth.user.id_token, campaign_id);
        setPartnerID(ret["partner_id"]);
        setAdvertiserID(ret["advertiser_id"]);
        setCampaignName(ret["campaign_name"]);
        let channel = ret["channel"];
        setChannel(channel);
        if (!SupportedChannel.includes(channel)) {
          throw new Error(`${channel} is not supported.`);
        }
        setTCCCOU(ret["tccc_ou"]);
        setTCCC_Country(ret["tccc_country"]);
        setButtonText("Onboard Campaign");
        setShowBanner(true);
        setShowError(false);

        setSuccessMessage("Validation passed successfully");
        setIsCampaignIdDisabled(true);
      } catch (error) {
        setErrorMessage(error.message);
        setShowBanner(true);
        setShowError(true);
        console.error("Error submitting form:", error);
      } finally {
        setLoading(false); // Stop loading state
      }
    } else if (buttonText === "Onboard Campaign") {
      console.log("Onboard campaign...");
      setLoading(true);
      try {
        let req = {
          campaign_id: campaign_id,
          campaign_name: campaignName,
          advertiser_id: advertiserID,
          partner_id: partnerID,
          channel: channel,
          tccc_ou: tccc_ou,
          tccc_country: tccc_country,
        };
        await OnboardCampaign(auth.user.id_token, req);
        setShowBanner(true);
        setShowError(false);

        setSuccessMessage("Campaign onboarded successfully");
        setIsCampaignIdDisabled(false);
      } catch (error) {
        setErrorMessage(error.message);
        setShowBanner(true);
        setShowError(true);
        setIsCampaignIdDisabled(false);
        console.error("Error submitting form:", error);
      }
      setCampaignID("");
      setCampaignName("");
      setPartnerID("");
      setAdvertiserID("");
      setChannel("");
      setTCCCOU("");
      setTCCC_Country("");
      setLoading(false);
      setButtonText("Validate Campaign"); // Change button text after operation
    }
  };
  return (
    <div className="centered-grid">
      <Container>
        <div style={{ marginBottom: '16px' }}>
          {showBanner &&
            (showError ? (
              <Alert message="Error" description={errorMessage} type="error" showIcon closable onClose={() => setShowBanner(false)} />
            ) : (
              <Alert message="Success" description={successMessage} type="success" showIcon closable onClose={() => setShowBanner(false)} />
            ))}
        </div>
        <Form>
          {loading && <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}><Spin size="large" /></div>}
          <Row>
            <Form.Label column="lg" lg={2}>
              Campaign ID
            </Form.Label>
            <Col lg={2}>
              <Form.Control
                size="lg"
                type="text"
                placeholder="Campaign ID"
                value={campaign_id}
                onChange={(e) => setCampaignID(e.target.value)}
                disabled={isCampaignIdDisabled}
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Form.Label column="lg" lg={2}>
              Campaign Name
            </Form.Label>
            <Col lg={12}>
              <Form.Control
                size="lg"
                type="text"
                placeholder="Campaign Name"
                value={campaignName}
                disabled
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Form.Label column="lg" lg={2}>
              Advertiser ID
            </Form.Label>
            <Col lg={2}>
              <Form.Control
                size="lg"
                type="text"
                placeholder="Advertiser ID"
                value={advertiserID}
                disabled
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Form.Label column="lg" lg={2}>
              Channel
            </Form.Label>
            <Col lg={2}>
              <Form.Control
                size="lg"
                type="text"
                placeholder="Channel"
                value={channel}
                disabled
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Form.Label column="lg" lg={2}>
              Partner ID
            </Form.Label>
            <Col lg={2}>
              <Form.Control
                size="lg"
                type="text"
                placeholder="Partner ID"
                value={partnerID}
                disabled
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Form.Label column="lg" lg={2}>
              TCCC OU
            </Form.Label>
            <Col lg={2}>
              <Form.Control
                size="lg"
                type="text"
                placeholder="TCCC OU"
                value={tccc_ou}
                disabled
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Form.Label column="lg" lg={2}>
              TCCC Country
            </Form.Label>
            <Col lg={2}>
              <Form.Control
                size="lg"
                type="text"
                placeholder="TCCC Country"
                value={tccc_country}
                disabled
              />
            </Col>
          </Row>
          <br />
          <Button
            type="primary"
            size="large"
            disabled={loading}
            loading={loading}
            onClick={!loading ? handleValidateCampaignClick : null}
          >
            {buttonText}
          </Button>
        </Form>{" "}
      </Container>
    </div>
  );
}

export default OnboardCampaignUI;
